import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

const CustomRedirectText = () => {
  const { translate } = useTranslations()

  return <span>{translate('RedirectingToDustin')}</span>
}

export default CustomRedirectText
